var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SloLoader',{class:{'mt-lg': true, 'mb-lg': _vm.cartLoading},attrs:{"loading":_vm.cartLoading,"size":"xl"}},[(_vm.cartTotalUnitCount > 0)?_c('MarketplaceFullCart'):_c('MarketplaceEmptyCart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }